// extracted by mini-css-extract-plugin
export default {"Group":"conversation-group_Group__N1I3S","Title":"conversation-group_Title__lL5ZT","Subgroup":"conversation-group_Subgroup__6836P"};